<script>
    import { onMount } from "svelte";
    import Modal from "./components/modalconfirm.svelte";
    import Card from "./components/card.svelte";
    import wrappedFetch from "../wrappedFetch.js";

    import Spinner from "./components/spinner.svelte";
    import DataTable from "../components/data-table.svelte";
    import Button from "./components/button.svelte";
    
    let users = [];
    let isPageLoading;

    onMount(async () => {
        await getUsersList();
        await get3PSOAccounts();
        //await determineIfIgnoredUsers();  
        await setButtonState();
        checkShowButton();       
    });

    let selectedRoleType;
    // let selectedUsers = [];
    let allAccounts = [];
    let staffAccounts = [];
    let pupilAccounts = [];
    let governorAccounts = [];
    let threepsoAccounts = [];
    //let resetMsg = "";    
   
    let showModal = false;
    let userToUpdate;
    let password = '';
    let showPassword = false;
    let passInput;
    let canChangePass;
    let changed = false;
    let forceChange = false;
    let isLGFLSchool=false;
    let isSyncUSOPassword = false;

    //responsible for button
    let buttonText = "";
    let buttonFunction = "";
    let anyIgnoredUser;
    let showMessage = false;
    let ignoredUserCount = 0
    let isButtonDisabled = false;

    //determining if a sync is already turned off for a user or not and updating the button accordingly 
    // const determineIfIgnoredUsers = () => {
        
    //     if (users) {
    //         for (let i = 0; i < users.length; i++) {
    //             if (users[i].isIgnored == true) {
    //                 anyIgnoredUser = true;
    //             }
    //         }

    //         if (anyIgnoredUser == true) {
    //             buttonText = "Resume All";
    //             buttonFunction = stopIgnoreAllSync;
    
    //         } else {
    //             buttonText = "Stop All"
    //             buttonFunction = ignoreAllSync;
    //         }

    //     }
    // };
    
    const handleChangeFilter = () => {    
        if (selectedRoleType == "S") users = staffAccounts;
        else if (selectedRoleType == "P") users = pupilAccounts;
        else if(selectedRoleType == "I") users = allAccounts.filter(u=> u.isIgnored == true);
        else if(selectedRoleType == "G") users = governorAccounts;
        else if(selectedRoleType == "PSO") users = threepsoAccounts;
        else users = allAccounts;

        //call function to check if button is to be displayed or not
        checkShowButton();

        ignoredUserCount = 0;
        setButtonState();
    };

    const checkShowButton = () => {
        showMessage = users.length === 0;
    };

    //checks and updates button state when using filteration system
    const setButtonState = () => {

        if (users) {
            for (let i = 0; i < users.length; i++) {
                if (users[i].isIgnored == true) {
                    ignoredUserCount++
                }
            }


            if (ignoredUserCount === users.length) {
                buttonText = "Resume All";
                buttonFunction = stopIgnoreAllSync;
    
            } else {
                buttonText = "Stop All"
                buttonFunction = ignoreAllSync;
            }

        }

    }

    const getUsersList = async () => {
        isPageLoading = true;
        //let resp = await fetch(`api/reports/GetUserList?sgid=172&sid=91724&types=${type}`, {
        let resp = await wrappedFetch(`/api/reports/GetUserList`, {
            method: "post",
        });
        let response = await resp.json();

        console.log(response);
        allAccounts = response.accounts;
        staffAccounts = response.accounts.filter((u) => u.role.includes("Staff"));
        pupilAccounts = response.accounts.filter((u) => u.role == "Pupil");
        governorAccounts = response.accounts.filter((u) => u.role.includes("Governor"));

        isLGFLSchool = response.isLGFL;
        isSyncUSOPassword = response.syncUsoPassword;
        users = allAccounts;
        // users.forEach((u) => {
        //     if (u.role == "Pupil") u.roleId = "P";
        //     if (u.role == "Staff") u.roleId = "S";
        // });
        isPageLoading = false;
    };

    const get3PSOAccounts = async () => {
        isPageLoading = true;
        
        let resp = await wrappedFetch(`/api/reports/Get3PSOList`, {
            method: "post",
        });
        let response = await resp.json();

        console.log(response);
        threepsoAccounts = response.accounts;
        isPageLoading = false;
    };

    

    const downloadUsers = ()=>{
        wrappedFetch(`/api/account/DownloadUsers`, {
            method: "get",
        });
    }

    const checkCanChangePassword = async (personId) => {
        return await wrappedFetch(
            `/api/account/CheckCanChangePasswordInUso?pid=${personId}`,
            { method: "post" }
            )
            .then((resp) => resp.text())
            .then((result) => {
                return result;
        });
    };

    const generatePassword = async () => {
        password = await wrappedFetch(`/api/account/GeneratePassword`, {
            method: "post",
            body: JSON.stringify(userToUpdate),
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((resp) => resp.text())
        .then((result) => {
            return result;
        });
        showPassword = false;
        togglePassword(passInput); 
        changed = false;
    };

    const changePassword = async () => {        
        await wrappedFetch(`/api/account/ChangePassword?password=${password}&forceChange=${forceChange}`, {
            method: "post",
            body: JSON.stringify(userToUpdate),
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((resp) => resp.text())
        .then((result) => {
            return result;
        });
        changed = true;
    };

    const ignoreSync = async(user)=>{
        let resp = await wrappedFetch(`/api/reports/IgnoreUserFromSync?personId=${user.personId}`, {
            method: "post",
        });
        let response = await resp.text();

        console.log("ignoreSync: ");
        console.log(response);

        user.isIgnored = true;
        users = [...users];
        //await getUsersList();
    }

    const stopIgnoreSync = async(user)=>{
        let resp = await wrappedFetch(`/api/reports/StopIgnoreSync?personId=${user.personId}&username=${u.universalId}`, {
            method: "post",
        });
        let response = await resp.text();

        console.log(response);

        user.isIgnored = false;
        users = [...users];
    }

    //function to turn off sync for all users selected at once
    //filtering out users who sync is already turned off for
    const ignoreAllSync = async()=>{

        let filterAlreadyPaused = [];

        for (let i = 0; i < users.length; i++) {
                if (users[i].isIgnored == false) {
                    filterAlreadyPaused.push(users[i]);
                }
            }
        
        if (filterAlreadyPaused) {

            filterAlreadyPaused.forEach(ignoreSync);
            buttonText = "Resume All";
            buttonFunction = stopIgnoreAllSync;

        }

        if (!isButtonDisabled) {
            isButtonDisabled = true;

            // Disable the button for 2 seconds (2000 milliseconds)
            setTimeout(() => {
                isButtonDisabled = false;
            }, 2000);
        }
        
    }

    //function to turn on sync for all users selected at once
    //filtering out users who sync is already turned on for
    const stopIgnoreAllSync = async()=>{
        
        let filterAlreadyUnpaused = [];
        for (let i = 0; i < users.length; i++) {
                if (users[i].isIgnored == true) {
                    filterAlreadyUnpaused.push(users[i]);
                }
            }
        
        if (filterAlreadyUnpaused) {

            filterAlreadyUnpaused.forEach(stopIgnoreSync);
            anyIgnoredUser = false;
            buttonText = "Stop All"
            buttonFunction = ignoreAllSync;
        }

        if (!isButtonDisabled) {
            isButtonDisabled = true;

            // Disable the button for 2 seconds (2000 milliseconds)
            setTimeout(() => {
                isButtonDisabled = false;
            }, 2000);
        }
       
    }


    function getSelectedUser(data){
        if (jQuery('div.dtr-bs-modal').length > 0){
            jQuery('.dtr-bs-modal').modal('hide');
        }
        return users.find(x => x.personId === (data));
    }

    document.addEventListener('click', function (event) {
        if (!event.target.matches('.MobileStopSync')) return;
            ignoreSync(getSelectedUser(parseInt(event.target.getAttribute('data'))));
    }, false);
    //document.addEventListener('click', function (event) {
        //if (!event.target.matches('.MobileResumeSync')) return;
            //stopIgnoreSync(getSelectedUser(parseInt(event.target.getAttribute('data'))));
    //}, false);
    document.addEventListener('click', function (event) {
        if (!event.target.matches('.MobileResetPassword')) return;
            stopIgnoreSync(getSelectedUser(parseInt(event.target.getAttribute('data'))));
    }, false);

    function MobileSyncOptions(event){
        if (event.detail.text == "TableUpdated"){
            jQuery(".table").on('click','.MobileStopSync', function () { 
                ignoreSync(getSelectedUser(parseInt(jQuery(this).attr('data'))));
            });
            jQuery(".table").on('click','.MobileResumeSync', function () { 
                stopIgnoreSync(getSelectedUser(parseInt(jQuery(this).attr('data'))));
            });
            jQuery(".table").on('click','.MobileResetPassword', function () { 
                var selectedUser = getSelectedUser(parseInt(jQuery(this).attr('data')));
                canChangePass = checkCanChangePassword(selectedUser.personId) == "" ? true : false;
                changed = false;
                userToUpdate = selectedUser;
                showModal = true;
            });
        }
    }
 
    const togglePassword = inputName => {
        showPassword = !showPassword;
        if (showPassword) 
            inputName.type = "text";
        else 
            inputName.type = "password";        
    };
    
    let order = [[1, "asc"]]
</script>

<style>
    .rowMenu {
        font-size: 10px;
        padding: 0.2rem 0.2rem;
    }

    .rowMenu:focus {
        box-shadow: none;
    }

    .btn-outline{
        color: #2e817d;
        border: 1px solid #2e817d;
        /* margin-left: 10px; */
    }
    .icon {
        pointer-events: initial !important;
        color: grey;
        border: 1px solid #c4cdd5;
        border-left-width: 0px;
        padding: 9px 9px;
    }
    .with-icon {
        border-right: 0px;
        border-radius: 0px !important;
    }
    /* .ignoredUser{
        background-color: #fdeded;
        cursor: default;
    } */
    
    .dropdown-menu {
        padding:0px !important;
    }

@media (max-width: 991px) {
    .order-sm-1{-ms-flex-order:1;order:1}
    .order-sm-2{-ms-flex-order:2;order:2}
}
@media (min-width: 991px) {
    .order-sm-1{-ms-flex-order:2;order:2}
    .order-sm-2{-ms-flex-order:1;order:1}
}
</style>

<svelte:head>
    <title>Users | Wavenet Nimbus</title>
</svelte:head>

<h1>Users</h1>
<p>You can view and manage the users that are being imported into Nimbus on this page. Please <a href="/api/account/DownloadUsers">click here</a> to download the full details for all users.</p>

{#if isPageLoading}
    <Spinner />
{:else}
    <Card>
        <div slot="body">
            <div class="form-group">
                <div class="row">
                    <div class="col-lg-4 order-sm-2">                    
                        <label for="role" style="display:block;">Filter:</label>
                        <select
                            style="width:300px;"
                            name="usersType"
                            class="custom-select"
                            bind:value={selectedRoleType}
                            on:change={handleChangeFilter}>
                                <option selected="selected" value="A">All Users</option>
                                <option value="S">Staff</option>
                                <option value="P">Pupils</option>
                                <option value="G">Governors</option>
                                <option value="PSO">3PSOs</option>
                                <option value="I">Not synced</option>
                        </select>
                    </div>
                    <!-- {#if !isLGFLSchool}
                    <div class="col-lg-8 order-sm-1" style="text-align:right;"><a href="/api/account/DownloadUsers" class="btn btn-primary" style="cursor:default;">
                        <span style="display:flex;"><span class="material-icons-outlined">file_download</span>&nbsp; Download users</span>
                    </a></div>
                    {/if} -->
                </div>
            </div>

            <div class="temp" style="float:right; padding-left:20px;">
                {#if !showMessage}
                <Button 
                    buttonText={buttonText}
                    on:click={buttonFunction}
                    disabled={isButtonDisabled}
                />
                {/if}
            </div>
            <DataTable {order} DataLength={users.length} ResponsiveHeader='0,1' message="There are no users to display." on:message={MobileSyncOptions}>
                <thead>
                    <tr>
                    <!-- <th style="width:10%" /> -->
                        <th>First Name </th>
                        <!-- <th >Middle Name</th> -->
                        <th scope="col" class="sorting_asc" aria-sort="ascending">Last Name</th>
                        <th >Email</th>
                        <!-- <th>Date of Birth</th> -->
                        <th>Role</th>
                        <th>Year</th>
                        <th>Class</th>
                        <th>Options</th>
                    </tr>
                </thead>
                <tbody>
                    {#each users as user}                
                        <tr style="{user.isIgnored?' background-color: #fdeded;cursor:default':''}" title={user.isIgnored?"This user is not currently being synced with any apps.":""}>
                            <!-- <td><input type="checkbox" bind:group={selectedUsers} value={user} /></td> -->
                            <td >{user.firstName}</td>
                            <!-- <td>{user.midName || ''}</td> -->
                            <td>{user.lastName}</td>
                            <td>{user.email || ''}</td>
                            <!-- <td>{user.dob || ''}</td> -->
                            <td>{user.role}</td>
                            <td>{user.yearGroup && user.role.indexOf("Staff") == -1?  user.yearGroup : ''}</td>
                            <td>{user.class && user.role.indexOf("Staff") == -1 ? user.class : ''}</td>
                            <td>                            
                                <div class="dropdown" style="display:inline">
                                    <!-- <span style="display: flex;">More&nbsp;<span class="material-icons-outlined" style="margin-right: 0 !important">keyboard_arrow_down</span></span> -->
                                    <a href="#" class="btn btn-grey rowMenu" style="cursor: default;" id="dropdownMenuLink"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">More&nbsp;<span class="material-icons" style="margin-right: 0 !important; font-size:18px !important;">keyboard_arrow_down</span></a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        {#if ! user.isIgnored}
                                            <a class="MobileStopSync dropdown-item" href="#" data={user.personId} >Stop Sync</a>
                                        {/if}
                                        {#if user.isIgnored}
                                            <a class="MobileResumeSync dropdown-item" href="#"  data={user.personId} on:click={async ()=>await stopIgnoreSync(user)}>Resume Sync</a> 
                                        {/if}
                                        <!--{#if !user.categories.includes(";3;") && !user.categories.includes(";4;") && !user.categories.includes(";4518;") && (isLGFLSchool || isSyncUSOPassword)}
                                            <a
                                                class="MobileResetPassword dropdown-item"
                                                role="button"
                                                data-toggle="modal"
                                                data={user.personId}
                                                href="#"
                                                on:click={ async () => {
                                                    canChangePass = await checkCanChangePassword(user.personId) == "" ? true : false;
                                                    changed = false;
                                                    userToUpdate = user;
                                                    showModal = true;
                                                }}>
                                                Reset Password </a>
                                        {/if}-->
                                    </div>
                                </div>
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </DataTable>
        </div>
    </Card>      
{/if}

<Modal 
    bind:showModal={showModal}
    targetClass="preview" 
    buttonText = {changed ? 'Close' : 'Change'}
    buttonClass="btn-primary"
    sizeClass="modal-md"
    on:confirm={ () => {
        if (!changed)
            changePassword();
        else
            showModal = false; 
    }} >
    <div slot="header">
        <h4 class="title">Reset Password for {userToUpdate.firstName} {userToUpdate.lastName} </h4>
    </div>
    <div slot="content">
        {#if canChangePass}
            <div class="form-group">
                <label for="pass" style="display:block;">Password: </label>
                <div style="display: inline-flex; width: 100%;">
                    <input id="pass" type="password" class="form-control with-icon" style="width: 70%" bind:this={passInput} bind:value={password} />   
                    {#if showPassword}
                        <span
                        class="icon is-small is-right fas fa-eye-slash"
                        aria-hidden="true"
                        on:click={() => {
                            togglePassword(passInput);
                        }} />
                    {:else}
                        <span
                        class="icon is-small is-right fas fa-eye"
                        on:click={() => {
                            togglePassword(passInput);
                        }} />
                    {/if}

                    {#if !changed}
                        <button class="btn btn-outline" style="margin-left: 10px;" on:click={generatePassword}>Generate</button> 
                    {/if}
                </div>
            </div>

            {#if !changed}
                <div class="form-check form-check-inline">
                    <label class="block" style="margin-top: 10px; margin-bottom: 0;"> 
                        <input type="checkbox" class="form-check-input" bind:checked={forceChange} /> Ask for a password change at next login? 
                    </label>
                </div>
            {:else}
                <button class="btn btn-outline" on:click={() => { passInput.select(); document.execCommand("copy");}}>Copy</button> 
            {/if}
        {:else}
            <p> Can not change password for {userToUpdate.firstName} {userToUpdate.lastName} </p>
        {/if}
    </div>
</Modal>

<!-- <Modal>
    <div slot="content">
        <Card>
            <div slot="body">
                The following user(s) password has been reset<br />
                {@html resetMsg}
            </div>
        </Card>
    </div>
</Modal> -->

<!--  </div>-->
